export const GENERIC = 'Error de conexión';
export const TRANSFER_INSPECTION = 'Error al transferir inspección';
